<template>
	<div>
		<template v-if="roleRules.ATTENDANCE_FLG === 'Y'">
			<template v-if="Object.keys(selectedStudent).length > 0">
				<template v-if="attendances.length > 0 || schoolsPeriodAttendanceChecks()">
					<section v-for="(school, idx) in attendanceList" :key="`school-${idx}`">
						<attendance-summary :school="school.ATTENDANCES"></attendance-summary>

						<h2>
							{{ school.SCHOOL_TITLE }}
						</h2>

						<template v-if="attendanceRules.show_counts && school.ATTENDANCES.length > 0">
                          <div
                              class="table-responsive"
                              tabindex="0"
                              role="region"
                              :aria-labelledby="`codeCountsCaption-${school.SCHOOL_ID}`"
                          >
                              <table class="table table-bordered">
                                  <caption class="sr-only" :id="`codeCountsCaption-${school.SCHOOL_ID}`">
                                      {{ school.SCHOOL_TITLE }} {{ $t('MAIN_CONTENT.Attendance.attendanceCodesCounts') }}
                                  </caption>

                                  <thead>
                                      <tr>
                                          <th scope="col">{{ $t('MAIN_CONTENT.Attendance.attendanceDescription') }}</th>
                                          <th scope="col">{{ $t('MAIN_CONTENT.Attendance.count') }}</th>

                                          <template v-if="getAttendanceCodeCountRows(school).some(row => row[1])">
                                              <th scope="col">{{ $t('MAIN_CONTENT.Attendance.attendanceDescription') }}</th>
                                              <th scope="col">{{ $t('MAIN_CONTENT.Attendance.count') }}</th>
                                          </template>
                                      </tr>
                                  </thead>

                                  <tbody>
                                      <tr
                                          v-for="(row, rowIdx) in getAttendanceCodeCountRows(school)"
                                          :key="`codeCounts-${school.SCHOOL_ID}-${rowIdx}`"
                                      >
                                          <td>{{ row[0].DESCRIPTION }}</td>
                                          <td>{{ row[0].COUNT }}</td>

                                          <template v-if="row[1]">
                                              <td>{{ row[1].DESCRIPTION }}</td>
                                              <td>{{ row[1].COUNT }}</td>
                                          </template>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </template>

						<div class="attendance-tabs">
							<tabs :options="{ useUrlFragment: false }" @changed="changedTab">
								<tab name="Daily Attendance"
										:id="'AttendanceTab'">
									<template v-if="school.ATTENDANCES.length > 0">
										<div class="table-responsive">
											
											<table-editable-list
												:columns="columns"
												:show-select="false"
												:show-actions="false"
											>
												<template slot="data-row">
													<template
														v-for="(attendance, index) in school.ATTENDANCES"
														
													>
														<table-list-row
															:columns="columns"
															:rowdata="attendance"
															:rowIndex="index"
															:showActions="false"
															:key="`attendance-${index}`"
														>
															<template slot="attendance">
																{{ attendance.DESCRIPTION }}
																<button
																	type="button"
																	class="btn btn-primary btn-sm pull-right"
																	v-if="!attendance.PENDING_FORM_EXISTS && onDemandForms.length > 0 && attendance.EXCUSED_STATUS !== 'E'"
																	@click="SubmitAbsenceFormButtonClick(attendance.FORMATTED_DATE, school.SCHOOL_ID)"
																>
																	{{ $t('MAIN_CONTENT.Attendance.submitAbsenceForm') }}
																</button>
																<span
																	class="badge badge-info pull-right"
																	v-else-if="attendance.PENDING_FORM_EXISTS && attendance.EXCUSED_STATUS !== 'E'"
																>
																	{{ $t('MAIN_CONTENT.Attendance.pendingForm') }}
																</span>
																<ul v-if="attendance.ATTENDANCE_DETAILS.length">
																	<li v-for="detail in attendance.ATTENDANCE_DETAILS" :key="detail.row_id">
																		{{detail.ATTENDANCE_CODE_DESC}} ({{detail.ATTENDANCE_CODE}}) -
																		<i>
																		<template v-if="!!detail.OUT_TIME && !!detail.IN_TIME">
																			Time Out: {{detail.OUT_TIME | time("mmmm, dd yyyy hh:mm:ss")}} - Time In: {{detail.IN_TIME | time("mmmm, dd yyyy hh:mm:ss")}}
																		</template>
																		<template v-if="!detail.OUT_TIME && !!detail.IN_TIME">
																		Time In: ( {{detail.IN_TIME | time("mmmm, dd yyyy hh:mm:ss")}} )
																		</template>
																		<template v-if="!!detail.OUT_TIME && !detail.IN_TIME">
																		Time Out: ( {{detail.OUT_TIME | time("mmmm, dd yyyy hh:mm:ss")}} )
																		</template>
																		<template v-if="!!detail.MINUTES">
																			- ({{ detail.MINUTES }} minutes)
																		</template>
																		</i>
																	</li>
																</ul>
															</template>
														</table-list-row>
													</template>
												</template>
											</table-editable-list>
										</div>
									</template>
									<template v-else>
										<div class="col-xs-12 alert alert-info">
											{{ $t('MAIN_CONTENT.Attendance.noAbsenceRecords') }}
										</div>
									</template>
								</tab>
								<template v-if="loadedPeriod">
									<tab :name="`${school.SCHOOL_TITLE} Period Attendance`"
										:id="'PeriodAttendanceTab'"
										v-if="!!periodAttendances[ school.SCHOOL_ID ] && periodAttendances[ school.SCHOOL_ID ].attendance_type === 'P'"
									>
										<template v-if="loadedPeriod">
											<h2>
												{{ $t( 'MAIN_CONTENT.Attendance.periodAttendance' ) }}
											</h2>
											<div class="row margin-bottom-5">
												<div class="col-xs-6 col-md-3 pointer">
													<button
														class="btn btn-default"
														tabindex="0"
														@click="showMonthSelectModal[school.SCHOOL_ID] = true"
													>
														<font-awesome-icon
															icon="list"
															size="lg"
															class="cursor-pointer"
															v-tooltip.top-center="{
																content: $t( 'MAIN_CONTENT.Attendance.selectMonthsToDisplay' ),
																trigger: 'hover'
															}"
														/>
														{{ $t( 'MAIN_CONTENT.Attendance.selectMonthsToDisplay' ) }}
													</button>

													<modal
														:modal-title="$t( 'MAIN_CONTENT.Attendance.selectMonthsToDisplay' )"
														:show="showMonthSelectModal[school.SCHOOL_ID]"
														dialog-size="lg"
														:name="'monthsToDisplay_' + school.SCHOOL_ID"
														@close="closeModal(school.SCHOOL_ID)"
													>
														<template slot-scope="modalProps">
															<div class="form-group" style="min-height: 135px;">
																<div class="col-xs-12">
																	<sapphire-toggle
																		class="col-xs-6 col-md-4 col-lg-3"
																		v-model="showFullYear"
																		:disabled="showFullYear"
																		:showInFront="false"
																		:label="$t( 'MAIN_CONTENT.Attendance.showFullYearAllCaps' )"
																		:ariaLabel="$t( 'MAIN_CONTENT.Attendance.showFullYearAllCaps' )"
																	>
																	</sapphire-toggle>
																</div>
																<!-- List of selected months -->
																<div class="col-xs-12">
																	<ul class="selected-months-list">
																		<li
																			v-for="( month, monthsInYearIndex ) in monthsInSchoolYear"
																			:key="`months_list_${monthsInYearIndex}`"
																			data-columns="3"
																		>
																			<sapphire-toggle
																				class="col-xs-6 col-md-4 col-lg-3"
																				v-model="month.checked"
																				:label="month.name"
																				:showInFront="false"
																				:ariaLabel="month.name"
																				@input="if( month.checked ) { showFullYear = false }"
																			>
																			</sapphire-toggle>
																		</li>
																		<li>
																		</li>
																	</ul>
																</div>
															</div>
														</template>
													</modal>
												</div>
												<button
													class="col-xs-6 col-md-3 pointer btn btn-default"
													tabindex="0"
													@click="showPeriodAttendanceCodeModal[school.SCHOOL_ID] = true"
												>
													<font-awesome-icon
														icon="list"
														size="lg"
														v-tooltip.top-center="{
															content: $t( 'MAIN_CONTENT.Attendance.periodAttendanceCodesLegend' ),
															trigger: 'hover'
														}"
													>
													</font-awesome-icon>
													{{ $t( 'MAIN_CONTENT.Attendance.periodAttendanceCodesIcon' ) }}
												</button>
											</div>

											<br />

											<modal
												:modal-title="$t( 'MAIN_CONTENT.Attendance.periodAttendanceCodes' )"
												:show="showPeriodAttendanceCodeModal[school.SCHOOL_ID]"
												dialog-size="md"
												:name="'periodAttendanceCodes_' + school.SCHOOL_ID"
												@close="closeModal(school.SCHOOL_ID)"
											>
												<template slot-scope="modalProps">
													{{'periodAttendanceCodes_' + school.SCHOOL_ID}}
												</template>
												<template slot-scope="modalProps">
													<table-editable-list
														:columns="
															[
																{
																	heading: 'Attendance Code',
																	key: 'ATTENDANCE_CODE',
																	customCol: 'code'
																},
																{
																	heading: 'Description',
																	key: 'ATTENDANCE_CODE_DESC',
																	customCol: 'desc'
																}
															]
														"
														:show-select="false"
														:show-actions="false"
													>
														<template slot="data-row">
																<tr
																	v-for="( code, codeIndex ) in usedPeriodAttendanceCodesList( school.SCHOOL_ID )"
																	:key="`periodCodes_${code.ATTENDANCE_CODE}_${codeIndex}`"
																>
																	<td>{{ code.ATTENDANCE_CODE }}</td>
																	<td>{{ code.ATTENDANCE_CODE_DESC }}</td>
																</tr>
															</template>
													</table-editable-list>
												</template>
												<template slot="footer">
													<button type="button" class="btn btn-transparent pull-right" @click="closeModal(school.SCHOOL_ID)">
														{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
													</button>
												</template>
											</modal>

											<div class="table-responsive">
												<table-editable-list :columns="getPeriodAttendanceColumns( school.SCHOOL_ID )"
																						:show-select="false"
																						:show-actions="false">
													<template slot="data-row">
														<template
															v-for="( day, dayIndex ) in periodAttendances[ school.SCHOOL_ID ].days"
														>
															<tr
																:key="`days_${dayIndex}_school_${school.SCHOOL_ID}`"
																v-if="isSelectedDate( formatDate( day, 'MMMM' ) ) || showFullYear"
															>
																<td>
																	{{ day }}
																</td>
																<template v-for="( period, periodName ) in getPeriodAttendanceColumns( school.SCHOOL_ID )">
																	<td
																		:key="`periods_period_${periodName}_days_${dayIndex}`"
																		v-if="period.heading !== 'Date'"
																		v-tooltip.top-center="{
																			content: getPeriodCodeDetail(
																				period.heading,
																				day,
																				school.SCHOOL_ID,
																				getAttendanceCode( school.SCHOOL_ID, day, period.heading )
																			),
																			trigger: 'hover click'
																		}"
																	>
																		<!-- {{ getAttendanceCode( school.SCHOOL_ID, dayName, period ) }} -->
																		{{ getAttendanceCode( school.SCHOOL_ID, day, period.heading ) }}
																	</td>
																</template>
															</tr>
														</template>
													</template>
												</table-editable-list>
											</div>
										</template>
									</tab>
								</template>
							</tabs>
						</div>
					</section>
				</template>
				<template v-else>
					<div class="col-xs-12 alert alert-info">
						{{ $t('MAIN_CONTENT.Attendance.noAbsenceRecords') }}
					</div>
				</template>
			</template>
			<template v-else>
				{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
			</template>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.Attendance.youDoNotHaveAccessToThisStudentWithPeriod') }}
		</template>
		<modal
			:modal-title="$t('MAIN_CONTENT.StudentDataForms.onDemandFormsTitleCase')"
			:show="showModal"
			dialog-size="md"
			name="attendanceFormModal"
			@close="closeOnDemandFormModal()"
		>
			<template slot-scope="modalProps">
				<!-- Start of Forms -->
				<table-editable-list :columns="onDemandColumns"
															:headerClasses="'th-left'"
															:show-select="false"
															:show-actions="false">
					<template slot="data-row">
						<template v-for="(form, studentDataFormsIdx) in onDemandForms">
							<table-list-row :key="`studentDataForms-${ studentDataFormsIdx }`"
															:columns="onDemandColumns"
															:rowdata="form"
															:useAnchor="false"
															:showActions="false"
															:rowIndex="studentDataFormsIdx">
							</table-list-row>
						</template>
					</template>
				</table-editable-list>
			</template>
			<template slot="footer">
				<button type="button" class="btn btn-transparent pull-right" @click="closeOnDemandFormModal()">
					{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
	import { Tabs, Tab } from 'vue-tabs-component';

	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';
	import SapphireToggle from 'COMMONS/SapphireToggle/SapphireToggle.vue';
	import Modal from 'COMMONS/shared/Modal/Modal.vue';

	import Attendance from '../api/Attendance';
	import StudentDataForms from '../api/StudentDataForms';

	import AttendanceSummary from './AttendanceSummary.vue';

	export default {
		data() {
			return {
				attendances: [],
				periodAttendances: [],
				loadedPeriod: false,
				showPeriodAttendanceCodeModal: {
					'03': false,
					'02': false
				},
				showMonthSelectModal: {
					'03': false,
					'02': false
				},
				attendanceRules:{
					'show_minutes': false,
					'show_comments': false,
					'show_counts': false
					
				},
				showFullYear: false,
				selectedTab: 'AttendanceTab',
				monthsInSchoolYear: [],
				onDemandForms: [],
				showModal: false,
				activeDate: ""
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
			columns() {
				let colArray = [
					{
						heading: this.$t( 'MAIN_CONTENT.Attendance.date' ),
						key: 'FORMATTED_DATE',
						customCol: 'date'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.Attendance.day' ),
						key: 'DAY',
						customCol: 'day'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.Attendance.attendanceDescription' ),
						key: 'DESCRIPTION',
						customCol: 'attendance'
					}
				];

				if(this.roleRules.ATTENDANCE_MINUTES_FLG === 'Y') {
					colArray.push({
						heading: this.$t( 'MAIN_CONTENT.Attendance.minutes' ),
						key: 'ELAPSED_TIME',
						customCol: 'minutes'
					});
				}

				if(this.roleRules.ATTENDANCE_COMMENTS_FLG === 'Y') {
					colArray.push({
						heading: this.$t( 'MAIN_CONTENT.Attendance.comments' ),
						key: 'COMMENTS',
						customCol: 'comments'
					});
				}

				return colArray;
			},
			attendanceList() {
				let list = [];
				let index = -1;

				for( let i in this.attendances ) {
					let attendance = this.attendances[i];

					if( +i === 0 || attendance.SCHOOL_ID.toString() !== this.attendances[+i - 1].SCHOOL_ID.toString() ) {
						list.push(
							{
								SCHOOL_ID: attendance.SCHOOL_ID,
								SCHOOL_TITLE: attendance.SCHOOL_TITLE,
								ATTENDANCES: []
							}
						);
						index++;
					}

					list[index].ATTENDANCES.push(attendance);
				}

				for( let s in this.periodAttendances ) {
					if( list.length === 0 ) {
						list.push(
							{
								SCHOOL_ID: this.periodAttendances[ s ].school.SCHOOL_ID,
								SCHOOL_TITLE: this.periodAttendances[ s ].school.SCHOOL_TITLE,
								ATTENDANCES: []
							}
						);
					} else {
						let schoolExists = false;
						for( let l in list ) {
							if( list[ l ].SCHOOL_ID.toString() === s.toString() ) {
								schoolExists = true;
							}
						}
						if( !schoolExists ) {
							list.push(
								{
									SCHOOL_ID: this.periodAttendances[ s ].school.SCHOOL_ID,
									SCHOOL_TITLE: this.periodAttendances[ s ].school.SCHOOL_TITLE,
									ATTENDANCES: []
								}
							);
						}
					}
				}

				return list;
			},
			onDemandColumns() {
				return [
					{
						customColumn: 'form',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.formLabel'),
						key: 'DV_FORM_NAME',
						type: 'link',
						link: 'LINK'
					},
					{
						customColumn: 'description',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.descriptionLabel'),
						key: 'DV_FORM_DESC'
					},
					{
						customColumn: 'status',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.status'),
						key: 'STATUS'
					},
					{
						customColumn: 'closeTime',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.openUntilTitleCase'),
						key: 'DV_FORM_END_DT_DISPLAY'
					},
					{
						customColumn: 'submissionCount',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.submissionsTitleCase'),
						key: 'SUBMISSION_COUNT'
					},
					{
						customColumn: 'lastSubmission',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.lastSubmittedTitleCase'),
						key: 'LAST_SUBMITTED_DATE'
					 }
				];
			}
		},
		watch: {
			loadedPeriod() {
				if( this.loadedPeriod ) {
					let attendanceDateMonths = [];

					let endOfSchoolYear = null;
					let startOfSchoolYear = null;

					// loop through school
					for( let s in this.periodAttendances ) {
						let school = this.periodAttendances[ s ];

						if( !endOfSchoolYear || endOfSchoolYear < moment( school.school.SCHOOL_END_DATE ) ) {
							endOfSchoolYear = moment( school.school.SCHOOL_END_DATE );
						}

						if( !startOfSchoolYear || startOfSchoolYear < moment( school.school.SCHOOL_START_DATE ) ) {
							startOfSchoolYear = moment( school.school.SCHOOL_START_DATE );
						}

						// loop through attendance
						for( let d in school.days ) {
							let day = school.days[ d ];

							// if( !attendanceDateMonths.includes( moment( day ) ) )
							attendanceDateMonths.push( moment( day ).format( 'MMMM' ) );
						}
					}

					// Get School start date month from moment js and then add to sorted declaration below
					let passedEndOfSchoolYear = moment() > endOfSchoolYear;
					let beforeStartOfSchoolYear = moment() < startOfSchoolYear;
					let startOfSchoolMonth = moment( startOfSchoolYear ).format( 'MMMM' );
					let endOfSchoolMonth = moment( endOfSchoolYear ).format( 'MMMM' );
					let monthToUse = null;

					if( beforeStartOfSchoolYear ) {
						monthToUse = startOfSchoolMonth;
					} else if( passedEndOfSchoolYear ) {
						monthToUse = startOfSchoolMonth;
					} else {
						monthToUse = moment().format( 'MMMM' );
					}

					let sorted = this.sortMonth(
						[
							...new Set( attendanceDateMonths )
						],
						!beforeStartOfSchoolYear && !passedEndOfSchoolYear ?
							startOfSchoolMonth :
							monthToUse
					);

					for( let s in sorted ) {
						this.monthsInSchoolYear.push( {
							name: sorted[ s ],
							month_index: s,
							checked: !passedEndOfSchoolYear ? monthToUse === sorted[ s ] : sorted[ s ] === endOfSchoolMonth
						} );
					}
				}
			},
			showFullYear( newVal, oldVal ) {
				if( newVal ) {
					for( let m in this.monthsInSchoolYear ) {
						this.monthsInSchoolYear[ m ].checked = false;
					}
				}
			}
		},
		methods: {
			getAttendanceCodeCountRows( school ) {
				let counts = {};
				let order = [];

				for( let i in school.ATTENDANCES ) {
					let attendance = school.ATTENDANCES[ i ];

					if( !counts[ attendance.ATTENDANCE_CODE ] ) {
						counts[ attendance.ATTENDANCE_CODE ] = {
							DESCRIPTION: attendance.DESCRIPTION,
							COUNT: 0
						};
						order.push( attendance.ATTENDANCE_CODE );
					}

					counts[ attendance.ATTENDANCE_CODE ].COUNT++;
				}
				order.sort( ( a, b ) => a.localeCompare( b ) ); 
				// pair codes up so they render as two Code/Count column pairs
				let rows = [];
				for( let c = 0; c < order.length; c += 2 ) {
					let row = [];
					for( let p = c; p < c + 2 && p < order.length; p++ ) {
						row.push( {
							CODE: order[ p ],
							DESCRIPTION: counts[ order[ p ] ].DESCRIPTION,
							COUNT: counts[ order[ p ] ].COUNT
						} );
					}
					rows.push( row );
				}

				return rows;
			},
			getShowPeriodAttendanceCodeModal(schoolId){
				return !!this.showPeriodAttendanceCodeModal[schoolId] ? this.showPeriodAttendanceCodeModal[schoolId] : false;
			},
			getShowMonthSelectModal(schoolId){
				return !!this.showMonthSelectModal[schoolId] ? this.showMonthSelectModal[schoolId] : false;
			},
			SubmitAbsenceFormButtonClick( attendDate, schoolID ) {
				this.activeDate = attendDate;
				if( this.onDemandForms.length > 1 ) {
					this.openModal();
				} else {
					this.$router.push( `/school/${schoolID}${ this.onDemandForms[ 0 ].LINK }` );
				}
			},
			openModal(){
				this.showModal = true;
			},
			loadOnDemandForms() {
				const self = this;

				let forms = new StudentDataForms({
					routeParams: { setting: 'on-demand-forms' },
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						LIMIT_TO_ATTENDANCE_WIDGET: "Y"
					}
				});

				const promise = forms.get();

				promise.then(response => {
					let displayData = [];

					for(let f in forms.getResponseData()) {
						let form = forms.getResponseData()[f];

						form.STATUS = form.FORM_STATUS_FLG === 'O' ?
							'Started' : 'Open';

						form.DV_FORM_BEG_DT_DISPLAY = self.$options.filters.datetime(form.DV_FORM_BEG_DT);
						form.DV_FORM_END_DT_DISPLAY = self.$options.filters.datetime(form.DV_FORM_END_DT);
						form.LINK = `/on-demand-form/form/${form.DV_FORM_ID}/ins/${form.INSTANCE_ID}`;

						displayData.push(form);
					}

					self.$set(self, 'onDemandForms', displayData);
				});
			},
			changedTab( selectedTab ) {
				this.selectedTab = selectedTab.tab.id;
			},
			selectedMonthText( { name } ) {
				return `${name}`;
			},
			loadAttendanceRules() {
				const rules = new Attendance({
					route: 'attendance/rules',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				rules.get()
					.then(response => {
						const theRules = response.data.data;
						this.attendanceRules.show_comments = theRules.show_comments === true;
						this.attendanceRules.show_counts   = theRules.show_counts === true;
						this.attendanceRules.show_minutes  = theRules.show_minutes === true;
					})
					.catch(error => {
						console.error('Failed to load attendance rules:', error);
						// fall back to safe defaults
						this.attendanceRules.show_comments = false;
						this.attendanceRules.show_counts   = false;
						this.attendanceRules.show_minutes  = false;
					});
			},
			loadAttendanceData() {
				const self = this;

				let attendance = new Attendance({
					route: 'attendance',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = attendance.get();

				promise.then(response => {
					let data = response.data.data;

					for(let i in data) {
						data[i].FORMATTED_DATE = moment( data[i].DATE, "MM/DD/YYYY" ).format( "MM/DD/YYYY" );
						data[i].DAY = moment( data[i].DATE, "MM/DD/YYYY" ).format( 'ddd' );
						data[i].DESCRIPTION = `${data[i].ATTENDANCE_CODE} - ${data[i].ATTENDANCE_CODE_DESC}`;
						data[i].ELAPSED_TIME = data[i].TARDY_MINUTES > 0 ? `${data[i].TARDY_MINUTES}` : '';
					}

					self.$set( self, 'attendances', response.data.data );
					self.loadOnDemandForms();
				})
				.catch(error => {
					console.log(error);
				});
			},
			loadPeriodAttendance() {
				const self = this;

				let attendance = new Attendance({
					route: 'attendance/period',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = attendance.get();

				promise.then( response => {
					self.$set( self, 'periodAttendances', attendance.getResponseData() );
					self.loadedPeriod = true;
				})
				.catch( error => {
					console.log( error );
				});
			},
			getPeriodAttendanceColumns( school ) {
				let periodAttendance = [
					{
						heading: this.$t( 'MAIN_CONTENT.Attendance.date' ),
						key: 'FORMATTED_DATE',
						customCol: 'date'
					}
				];

				let selectedSchool = this.periodAttendances[ school ];

				for( let p in selectedSchool.periods ) {
					let period = selectedSchool.periods[ p ];

					periodAttendance.push( {
						heading: period.PERIOD_CODE,
						key: 'ATTENDANCE_CODE',
						customCol: 'period'
					} );
				}

				return periodAttendance;
			},
			formatDate( date, displayType = 'MM/DD/YYYY' ) {
				return moment( date ).format( displayType );
			},
			sortMonth( array, first ) {
				const months = {
					January: 1,
					February: 2,
					March: 3,
					April: 4,
					May: 5,
					June: 6,
					July: 7,
					August: 8,
					September: 9,
					October: 10,
					November: 11,
					December: 12
				};

				return array.sort( ( a, b ) =>
					( months[a] < months[first] ) - ( months[b] < months[first] ) || months[a] - months[b]
				);
			},
			isSelectedDate( monthName ) {
				let selected = false;

				for( let m in this.monthsInSchoolYear ) {
					let month = this.monthsInSchoolYear[ m ];

					if( month.name === monthName ) {
						selected = month.checked;
						break;
					}
				}

				return selected;
			},
			getPeriodCodeDetail( period, date, schoolID, code ) {
				let message = '';

				if( !!code ) {
					for( let d in this.periodAttendances[ schoolID ].codes ) {
						let codeDetails = this.periodAttendances[ schoolID ].codes[ d ];

						if( code === codeDetails.ATTENDANCE_CODE ) {
							message = this.$t(
								'MAIN_CONTENT.Attendance.periodTooltip',
								{
									date: date,
									period: period,
									code: codeDetails.ATTENDANCE_CODE,
									description: codeDetails.ATTENDANCE_CODE_DESC
								}
							);
						}
					}
				}

				return message;
			},
			closeModal(schoolId) {
				this.showPeriodAttendanceCodeModal[schoolId] = false;
				this.showMonthSelectModal[schoolId] = false;
			},
			closeOnDemandFormModal() {
				this.showModal = false;
			},
			usedPeriodAttendanceCodesList( building ) {
				let codes = [];
				let allCodes = this.periodAttendances[ building ].codes;

				for( let a in this.periodAttendances[ building ].attendance ) {
					let attendance = this.periodAttendances[ building ].attendance[ a ];

					for( let p in attendance ) {
						let period = attendance[ p ];

						for( let a in allCodes ) {
							let all = allCodes[ a ];

							if( all.ATTENDANCE_CODE === period.ATTENDANCE_CODE && !this.containsObject( all, codes ) ) {
								codes.push( all );
							}
						}
					}
				}

				return codes;
			},
			containsObject( obj, list ) {
				for( let i in list ) {
					if( list[i] === obj ) {
						return true;
					}
				}

				return false;
			},
			schoolsPeriodAttendanceChecks() {
				for( let s in this.periodAttendances ) {
					if( this.periodAttendances[ s ].attendance_type === 'P' ) {
						return true;
					}
				}

				return false;
			},
			getAttendanceCode( schoolID, day, period ) {
				return !!this.periodAttendances[ schoolID ].school.days[ day ][ period ] ?
					this.periodAttendances[ schoolID ].school.days[ day ][ period ].ATTENDANCE_CODE :
					"";
			},
			timeFormat( date, outpoutFormat ) {
				return moment( String( date ), "HH:mm" ).format( outpoutFormat );
			}
		},
		created() {
			this.$store.commit( 'setTitleIcon', 'list-alt' );
			this.$store.commit( 'setTitle', 'MAIN_CONTENT.Attendance.sideMenuAttendanceLink' );
			this.$store.commit( 'setUseHeader', true );

			if( Object.keys( this.selectedStudent ).length > 0 ) {
				if( this.roleRules.ATTENDANCE_FLG === 'Y' ) {
					this.loadAttendanceData();
					this.loadPeriodAttendance();
					this.loadAttendanceRules();
				}
			}
		},
		beforeRouteLeave( to, from, next ) {
			if( to.name === "OnDemandForm" ) {
				to.params.attendanceDate = this.activeDate;
				to.params.formAction = "submitExisting";
			}

			next();
		},
		directives: {
			'tooltip': VTooltip,
		},
		components: {
			AttendanceSummary,
			Modal,
			SapphireToggle,
			TableEditableList,
			TableListRow,
			Tabs,
			Tab
		}
	}
</script>

<style scoped>
	.margin-bottom-5 {
		margin-bottom: 5px;;
	}
</style>
